import { Pipe, PipeTransform } from '@angular/core';
import { ExportState } from '@app/shared/enums/ExportState.enum';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'exportState',
    standalone: false
})
export class ExportStatePipe implements PipeTransform {
  public exportState = ExportState;
  public exportStatesList: any[] = [];

  constructor(public translate: TranslateService) {
    this.getList();
   }

  transform(value: any): string {
    if (value === null || value === undefined) {
      return this.translate.instant('ENUMS.NO_STATE');
    }

    const states = Array.isArray(value) ? value : [value];

    if (states.length === 0) {
      return this.translate.instant('ENUMS.NO_STATE');
    }

    const translatedStates = states
      .map(state => {
        const key = Object.keys(ExportState).find(
          k => ExportState[k as keyof typeof ExportState] === state
        );
        return key ? this.translate.instant(`ENUMS.${key}`) : null;
      })
      .filter(Boolean);

    return translatedStates.length > 0
      ? translatedStates.join(', ')
      : this.translate.instant('ENUMS.NO_STATE');
  }

  getList() {
    this.exportStatesList = [];

    for (const [propertyKey, propertyValue] of Object.entries(ExportState)) {
      if (!Number.isNaN(Number(propertyKey))) {
        continue;
      }
      const nameAndText = this.translate.instant('ENUMS.' + propertyKey);
      this.exportStatesList.push({ id: propertyValue, name: nameAndText, text: nameAndText });
    }

    return this.exportStatesList;
  }

  getById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(ExportState)) {
      if (propertyValue == Id) {
        const nameAndText = this.translate.instant('ENUMS.' + propertyKey);
        return { id: propertyValue, name: nameAndText, text: nameAndText };
      }
    }
    return null;
  }

  getNameById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(ExportState)) {
      if (propertyValue == Id) {
        return 'ENUMS.' + propertyKey;
      }
    }
    return null;
  }
}
